import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

// Shown to mediums whose Google Calendar connection failed (expired / revoked access).
// The backend flags this on the user payload; it clears once the calendar is relinked.
export default function GoogleCalendarDisconnectedBanner() {
  const { role } = useSelector((state) => state.auth);
  const user = useSelector((state) => state.user.user);

  if (role !== "medium" || !user || !user.google_calendar_disconnected) {
    return null;
  }

  return (
    <div
      role="alert"
      style={{
        background: "#fdecea",
        border: "1px solid #f5c2c0",
        color: "#7a1f1a",
        padding: "10px 16px",
        margin: "10px 15px",
        borderRadius: "4px",
        fontSize: "14px",
        lineHeight: 1.4,
      }}
    >
      <b>Your Google Calendar is disconnected.</b> Your availability and bookings
      are not syncing until you reconnect it.{" "}
      <Link to="/integration" style={{ fontWeight: 700, textDecoration: "underline" }}>
        Reconnect now
      </Link>
    </div>
  );
}
